export default __webpack_public_path__ + "static/media/logo-dark.f37f74b3.png";